import React, { useState } from "react";
import { Row  } from "react-bootstrap";
import "../scss/claimbulkprocess.scss";
import BulkApproval from "./bulkApproval";
import RunNumberDetails from "./runNumberDetails";
import Utrupload from "./UTRUpload";

const ClaimBulkProcess = (props) => {
  const {productNames, roleDataCookie} = props
  const [buttonsStatus, setButtonsStatus] = useState("Bulk")

  return (
    <section className="p-4">
      <h1 className="headerclaim">
        Claim Bulk Process
      </h1>
      <hr />
      <div>
        <Row>
          <div className="form-group" style={{ display: 'flex', gap: '1rem',marginLeft:'2rem' }}>
            <button className={`${buttonsStatus == "Bulk" ? 'btn btn-success mt-4 mb-4 px-4': 'btn btn-outline-success mt-4 mb-4 px-4'}`} onClick={() => setButtonsStatus("Bulk")}>Bulk Approval</button>
            <button className={`${buttonsStatus == "Run" ? 'btn btn-success mt-4 mb-4 px-4': 'btn btn-outline-success mt-4 mb-4 px-4'}`} onClick={() => setButtonsStatus("Run")}>Run Number Status</button>
            <button className={`${buttonsStatus == "UTR" ? 'btn btn-success mt-4 mb-4 px-4': 'btn btn-outline-success mt-4 mb-4 px-4'}`} onClick={() => setButtonsStatus("UTR")}>UTR Upload</button>
          </div>
        </Row>
      </div>
      {
         buttonsStatus == "Bulk" && (
          <BulkApproval productNames={productNames}/>
         )
      }
       {
         buttonsStatus == "Run" && (
          <RunNumberDetails/>
         )
      }
       {
         buttonsStatus == "UTR" && (
          <Utrupload productNames={productNames} roleDataCookie={roleDataCookie}/>
         )
      }
    </section>
  )
}
export default ClaimBulkProcess;